import Proxy from './Proxy';

class ContractProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/advertiser/contract', parameters);
  }

}

export default ContractProxy;
